import React from "react";
import home1 from "../../../assets/img/aboutImg.png";
import { WiDirectionUpRight } from "react-icons/wi";
import { CgArrowRight } from "react-icons/cg";
import { Link } from "react-router-dom";

import "./ServiceList.css";
function ServiceList() {
  return (
    <>
      <section className="serviceList sectionPD bgGray">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-12">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
                <div className="extra">
                  <strong>Leader on the market since 2002</strong>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <div className="aboutWooden">
                <h6>Welcome to Vinca Horticulture & Landscaping Pvt Ltd</h6>
                <h2>Innovative Landscaping Solutions for Every Space</h2>
                <p>
                  Vinca Horticulture & Landscape Pvt. Ltd. offers tech
                  integrated solutions to craft your landscaping fascination
                  into existence be it for the designing, implementation,
                  supplying and maintenance etc.
                </p>
                <p>
                  Our services are premium and yet affordable as we bring you
                  the panacea for all your “GROUNDSKEEPING” needs by offering
                  tailoring made solutions backed by over a decade of experience
                  of leadership team.
                </p>
                <p>
                  Vinca’s team of dedicated, qualified and skilled professionals
                  value the customers and helps them attaining their desired and
                  cherished results, right from the very beginning till their
                  dreamy products.
                </p>
               
                <Link to="/about" className="commonButton"> explore now</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServiceList;
